import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormField } from '../_shared/formfield/formfield.component.js';
import Header from '../_shared/header/header';
import Footer from '../_shared/footer/footer';
import flatten from '../_shared/util/flatten';

@inject('appStore', 'routerStore', 'form')
@observer
export class ExamplesComponent extends Component {
    render() {
        const { form } = this.props,
            errors = form.errors();

        return (
            <section className='examples'>
                <Header
                    titlePre='some examples for'
                    title='Forms'
                    idPrefix='exampleheader'
                    prev={{
                        onClick: () => this.onPrevious()
                    }}
                />

                <form className='ht-form'>
                    {form.map(field => {
                        field.errors = errors[field.path];

                        return (
                            <FormField
                                key={field.id}
                                field={field}
                                formValues={flatten(form.values())}
                            />
                        );
                    })}

                    <Footer
                        next={{
                            disabled: !form.isValid,
                            onClick: e => form.onSubmit(e)
                        }}
                        prev={{
                            onClick: () => this.onPrevious()
                        }}
                        showError={!form.isValid}
                        errorMessage={form.error}
                    />
                </form>
            </section>
        );
    }
}
